<template>
  <section>
    <b-carousel
      id="image-carousel"
      ref="dpcarousel"
      v-model="current"
      aria-label="DocuPet Product Image Carousel"
      :indicators="images.length > 1 ? showThumbnailControls : false"
      :controls="images.length > 1 ? showThumbnailControls : false"
      :interval="autoSlide ? 5000 : 0"
    >
      <b-carousel-slide v-for="(image, index) in images" :key="index">
        <template #img>
          <component
            :is="image.actionLink || image.actionHandler ? 'a' : 'div'"
            :href="image.actionLink || 'javascript:void(0)'"
            target="_self"
            @click="!!image.actionHandler ? image.actionHandler() : null"
          >
            <b-img
              :src="getImage(image.original)"
              :alt="image.imageAltText ? image.imageAltText : ''"
              class="d-block img-fluid w-100"
              center
            />
          </component>
        </template>
      </b-carousel-slide>
    </b-carousel>
  </section>
</template>

<script>
import getImage from '@/mixins/getImage';
import { KeyboardNavigationMixins } from '@/mixins/keyboardNavigation';

export default {
  name: 'Carousel',
  mixins: [getImage, KeyboardNavigationMixins],
  props: {
    images: {
      type: Array,
      required: true,
    },
    currImageIdx: {
      type: Number,
      default: 0,
    },
    showThumbnailControls: {
      type: Boolean,
      default: true,
    },
    autoSlide: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      current: 0,
      direction: 1,
      show: false
    };
  },
  watch: {
    currImageIdx: {
      immediate: true,
      handler: function () {
        if (this.currImageIdx !== this.current) {
          this.change(this.currImageIdx);
        }
      },
    },
  },
  mounted() {
    this.show = true;
    this.$nextTick(() => {
      const indicators = document.querySelector('#image-carousel .carousel-indicators');
      if (indicators) {
        indicators.setAttribute('role', 'tablist');
      }
    });
  },
  methods: {
    change(index) {
      this.$refs?.['dpcarousel']?.setSlide(index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/main';
.carousel {
  &.pointer-event {
    touch-action: pan-y pinch-zoom;
  }
  &::v-deep {
    .carousel-control-next,
    .carousel-control-prev {
      color: $dp-blue;
      border: none !important;
      top: initial !important;
      bottom: -14px !important;
      height: 48px !important;
      width: 30px !important;
      opacity: 1 !important;
      &:focus {
        outline: 1px auto $dp-blue !important;
      }
    }
    .carousel-control-prev-icon {
      transform: rotate(180deg);
    }
    .carousel-control-prev-icon,
    .carousel-control-next-icon {
      width: 100% !important;
      height: 100% !important;
      background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"%3E%3Cpath fill="%232c5bc5" d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/%3E%3C/svg%3E') !important;
    }
    .carousel-indicators {
      position: relative !important;
      margin-top: 30px;
      flex-wrap: wrap;
      li {
        background-color: $dp-gray-4 !important;
        width: 22px !important;
        height: 22px !important;
        margin-bottom: 6px;
        @include media-breakpoint-down(lg) {
          width: 15px !important;
          height: 15px !important;
        }
        border-radius: 50%;
        border-top: 0 !important;
        border-bottom: 0 !important;
        opacity: 1 !important;
        &.active {
          background-color: $dark !important;
        }
      }
    }
  }
}
</style>
